import users from "./users";
import currentUser from "./currentUser";
import currentCompany from "./currentCompany";
import companies from "./companies";
import globals from "./globals";
import textbausteine from "./textbausteine";
import currentKlausur from './currentKlausur'
import schueler from './schueler'

import { combineReducers } from "redux";

export default combineReducers({
  currentUser,
  currentCompany,
  users,
  companies,
  globals,
  textbausteine,
  currentKlausur,
  schueler
});
